@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
	--yF-theme-color: #19cc76;
	--yF-theme-accent: #142f48;
	--yF-theme-h-text: #142f48;
	--yF-hover-color: #16ac6b;
	--yF-bullet-bg: #bbf7d0;
}

select {
	appearance: none;
	background-image: url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20fill='none'%20viewBox='0%200%2020%2020'%3E%3Cpath%20stroke='%236b7280'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='1.5'%20d='M6%208l4%204%204-4'/%3E%3C/svg%3E");
	background-position: right 0.5rem center;
	background-repeat: no-repeat;
	background-size: 1.5em 1.5em;
	padding-right: 2.5rem;
	-webkit-print-color-adjust: exact;
	print-color-adjust: exact;
}

/* Remove spinner arrows from number inputs */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox: Remove spinner arrows from number inputs */
input[type="number"] {
	-moz-appearance: textfield;
}

@layer components {
	.yF-error-text {
		@apply !yF-mt-1 yF-text-xs yF-text-red-600;
	}
	.yF-input-error {
		@apply yF-ring-red-500;
	}
	.yF-input-focus {
		@apply yF-ring-gray-300 focus:yF-ring-[--yF-theme-color] focus:yF-ring-2;
	}
	.yF-input-default {
		@apply yF-block yF-w-full yF-rounded-md yF-shadow-sm yF-border-0 yF-py-2.5 yF-px-2.5 yF-text-gray-900 !yF-ring-1 yF-ring-inset placeholder:yF-text-gray-400 yF-text-base yF-leading-6 yF-bg-none focus:yF-ring-1 focus:yF-ring-inset focus-visible:yF-outline-[--yF-theme-color];
	}
	.yF-select-error {
		@apply yF-ring-red-500;
	}
	.yF-select-focus {
		@apply yF-ring-gray-300 focus:yF-ring-[--yF-theme-color] focus:yF-ring-2;
	}
	.yF-select-default {
		@apply yF-appearance-none yF-bg-white yF-block yF-w-full yF-rounded-md yF-shadow-sm yF-border-0 yF-py-2.5 yF-text-gray-900 !yF-ring-1 yF-ring-inset yF-pl-3 placeholder:yF-text-gray-400 yF-text-base yF-leading-6 focus:yF-ring-1 focus:yF-ring-inset focus-visible:yF-outline-[--yF-theme-color];
	}
	.yF-label {
		@apply yF-block yF-font-semibold yF-text-base yF-leading-6 yF-text-gray-900;
	}
}
